import { render, staticRenderFns } from "./sub-task-table.vue?vue&type=template&id=17d833a4"
import script from "./sub-task-table.vue?vue&type=script&lang=js"
export * from "./sub-task-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports